import { ptBR } from '@/i18n/pt-BR';
import { type ApiKeysErrorReason } from '@/lib/api_keys';

export function mapApiKeysErrorReason(reason: ApiKeysErrorReason): string {
  switch (reason) {
    case 'conflict':
      return ptBR.apiKeys.errorConflict;
    case 'not_found':
      return ptBR.apiKeys.errorNotFound;
    case 'validation':
      return ptBR.apiKeys.errorValidation;
    case 'network':
      return ptBR.apiKeys.errorNetwork;
    case 'unauthorized':
      return ptBR.apiKeys.errorUnauthorized;
    default:
      return ptBR.apiKeys.errorGeneric;
  }
}
